import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function CategoryNav() {
  return (
    <section className="py-16 bg-background-50">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2
            className="text-2xl md:text-3xl font-bold text-foreground-950"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            探索内容
          </h2>
          <p className="mt-2 text-foreground-600 text-sm">发现关于佐佐木希的一切</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-6 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}